import { STORAGE_KEYS } from "../constants";

/**
 * When the session ends (logout or forced sign-out), keep remembered email only if the user
 * previously checked "Remember me" (`rememberMe` === "true"). Otherwise clear stored email.
 */
export function applyRememberMeStorageOnSessionEnd() {
  try {
    const rememberMe = localStorage.getItem(STORAGE_KEYS.REMEMBER_ME) === "true";
    if (!rememberMe) {
      localStorage.removeItem(STORAGE_KEYS.REMEMBERED_EMAIL);
    }
  } catch {
    /* ignore private mode / quota */
  }
}
